/**
 * Brand body font (DM Sans), scoped to the chat surface.
 *
 * DM Sans is the intended body font in DESIGN.md but is not wired up as the
 * global `--font-sans`, so the app shell still renders in the system stack.
 * We apply it here, scoped to the chat panel, so the assistant reads on-brand
 * without changing typography across every screen. Promote to a global token
 * if/when the rest of the app adopts DM Sans.
 */
export const CHAT_FONT_FAMILY =
  "'DM Sans', ui-sans-serif, system-ui, sans-serif";
